@if ( recipient) {
  <div class="mb-3">
    <div class="mb-3">
      <h4>{{ title }} &nbsp;</h4>
      <p class="small text-muted">{{ description }} &nbsp;</p>
    </div>
  </div>

  <div [ngClass]="{'border-warning': errorMsg}" class="p-3 border rounded border-primary">
    @if ( errorMsg ) {
      <div class="form-group text-danger">{{ errorMsg | translate }}</div>
    }

    <div class="form-group mb-3">
      <label>{{ 'contacts.name' | translate }} *
        <div class="position-relative">
          <div class="input-group">
            <input (click)="toggleContactList(true, $event); filterContactsInput.focus()"
              [(ngModel)]="recipient.name"
              class="form-control border-right-0"
              placeholder="{{ 'signrequest.name_and_last_name' | translate }}" />
              <div (click)="filterContacts(); toggleContactList(true, $event)"
                (keydown.enter)="filterContacts(); toggleContactList(true, $event)"
                tabindex="0"
                role="button"
                class="input-group-append cursor-pointer border-left-0 p-3">
                <em class="fas fa-address-book fa-fw"></em>
              </div>
              <div #availableContactList
                [ngClass]="{ 'hide': !showContactList }"
                [style.z-index]="200"
                class="w-100 bg-white border border-primary position-absolute contact-listbox">
                <div class="input-group border-bottom">
                  <input #filterContactsInput
                    (input)="filterContacts()"
                    [(ngModel)]="contactFilter"
                    class="form-control border-0"
                    placeholder="{{ 'signrequest.choose_contact' | translate }}..."
                    type="text">

                    <div (click)="toggleContactList(false, $event)"
                      (keydown.enter)="toggleContactList(false, $event)"
                      tabindex="1"
                      role="button"
                      class="input-group-append cursor-pointer border-0 p-3">
                      <em class="fas fa-times fa-fw"></em>
                    </div>
                  </div>

                  <div class="contact-list">
                    @if ( contactFilter && noContactFound ) {
                      <div class="contacts p-3">
                        <p class="text-warning mb-4"><em class="fa fa-fw fa-exclamation-triangle"></em>
                        <span
                        [innerHTML]="'signrequest.no_contacts_found' | translate: {name: contactFilter }"></span>
                      </p>
                      <button (click)="createContact(recipient)" class="btn btn-block btn-outline-warning"
                        type="button"><em
                      class="fas fa-plus mr-2"></em> {{ 'contacts.new_contact_name' | translate: {name: contactFilter} }}
                    </button>
                  </div>
                }
                @else {
                <div class="add-new-contact border-bottom">
                  <button (click)="createContact(recipient)" class="btn btn-link btn-block"><em
                  class="fas fa-plus mr-2"></em> {{ 'contacts.new_contact' | translate }}</button>
                </div>
                <div class="contacts p-3">
                  @for (key of contactsMapKeys; track key) {
                    <div class="letter-group">
                      <div class="text-gray-dark d-flex">
                        <strong class="mr-2">{{ key }}</strong>
                        <hr class="my-2 w-100"/>
                      </div>
                      @for (contact of contactsMap.get(key); track contact) {
                        <div class="contact pl-3">
                          @if ( !emailAdded(contact.email) ) {
                            <div (click)="selectAvailableContact(contact, recipient, $event)"
                              (keydown.enter)="selectAvailableContact(contact, recipient, $event)"
                              tabindex="2"
                              class="contact-label">
                              {{ contact.name }}
                            </div>
                          }
                          @else {
                          <span class="text-muted">{{ contact.name }}</span>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </label>
</div>
<div class="signatory-email mb-4">
  <div class="form-group">
    <label for="signatoryEmailAddressField">{{ 'signrequest.email_address' | translate }} *
      <app-email-input (change)="validateRecipient()"
        (errors)="emailErrors($event)"
        [(value)]="recipient.email"
        id="signatoryEmailAddressField"
      [placeholder]="'signrequest.email_address' | translate"></app-email-input>
    </label>
  </div>
</div>

<div class="form-group mb-4">
  <label for="signatoryLanguageField">{{ 'signrequest.language' | translate }}&nbsp;*
    <app-language-input (change)="validateRecipient()"
      id="signatoryLanguageField"
    [(value)]="recipient.locale"></app-language-input>
  </label>
</div>

@if ( settings.signatoryAcceptance && !isEdelivery ) {
  @if ( recipient.signatoryRole !== 'CC' ) {
    <div class="form-group mb-4">
      <label class="signatory-section-title">{{ 'signrequest.signatory_role' | translate }}
        <div class="selector-as-btn-list mb-3">
          <div [class.selected]="'SIGN'===recipient.signatoryRole" class="checkbox c-checkbox">
            <label>
              <input (change)="setRole('SIGN')"
                [checked]="'SIGN'===recipient.signatoryRole"
                type="checkbox">
                <span class="label">{{ 'signrequest.role_sign' | translate }}</span>
              </label>
            </div>
            <div [class.selected]="'ACCEPTANCE'===recipient.signatoryRole" class="checkbox c-checkbox">
              <label>
                <input (change)="setRole('ACCEPTANCE')"
                  [checked]="'ACCEPTANCE'===recipient.signatoryRole"
                  type="checkbox">
                  <span class="label">{{ 'signrequest.role_acceptance' | translate }}</span>
                </label>
              </div>
            </div>
          </label>
        </div>
      }
    }



    @if ( settings.roles && (recipient.signatoryRole === 'SIGN') ) {
      <div class="form-group mb-1">
        <label>{{ 'signrequest.roles' | translate }}

          <select class="custom-select form-control" (change)="addRole($event)">
            <option></option>
            @for (role of settings.roles; track role) {
              <option>{{role}}</option>
            }
          </select>
        </label>
      </div>

      <div class="form-group mb-3">
        <ul class="list-group">
          @for (role of recipient.roles; track role) {
            <li class="list-group-item" >
              <div class="mt-2 inline-block">{{role}}</div>
              <button (click)="removeRole(role)"
                class="btn btn-link px-2 float-right"><em class="fas fa-trash-alt"></em></button>
              </li>
            }
          </ul>
        </div>
      }

      @if ( recipient.signatoryRole === 'SIGN' || recipient.signatoryRole === 'DELIVERY' ) {
        @if ( enabledPreviewMethods.length ) {
          <div class="form-group mb-3">
            <label for="previewAuthMethods">{{ 'signrequest.preview' | translate }}</label>
            <app-auth-methods (toggle)="toggleAuthentication($event, true)"
              [enabled]="enabledPreviewMethods"
              [disabled]="disabledAuthenticationMethods"
              [previewMethod]="true"
              [signatory]="recipient"
              id="previewAuthMethods">
            </app-auth-methods>
          </div>
        }

        @if ( idinAuthPreviewMethod ) {
          <hr/>
          <div [formGroup]="form" class="checkbox c-checkbox mb-3 form-group">
            <label for="automaticValidationIDIN" class="signatory-section-title mb-2 auto-validation">{{ 'edelivery.automatic_validation.idin' | translate}}</label>
            <div class="mb-2 mt-2"><small class="text-muted mb-2">{{'edelivery.automatic_validation_desc.idin' | translate}}</small></div>
            @if (isEdelivery ) {
              <label for="automaticValidationIDIN" >
                <input type="checkbox"
                  [id]="'automaticValidationIDIN'"
                  formControlName="automaticValidationIDIN"
                  [checked]="this.form.get('automaticValidationIDIN')?.value"
                  (click)="onAutomaticValidationCheck( 'idin')">
                  <span class="fa fa-check fa-fw"></span>
                </label>
              }
            </div>
          }

          @if ( irmaAuthPreviewMethod ) {
            <div [formGroup]="form" class="checkbox c-checkbox mb-3">
              <label>
                <span class="signatory-section-title mb-2 auto-validation">{{ 'edelivery.automatic_validation.irma' | translate}}</span>
                <br/><small class="text-muted">{{'edelivery.automatic_validation_desc' | translate}}</small>
                <div class="mt-2">
                  <input type="checkbox"
                    [id]="'automaticValidationIRMA'"
                    formControlName="automaticValidationIRMA"
                    [checked]="this.form.get('automaticValidationIRMA')?.value"
                    (click)="onAutomaticValidationCheck( 'irma')">
                    <span class="fa fa-check fa-fw"></span>
                  </div>
                </label>
              </div>
            }


            @if ( cscAuthPreviewMethod ) {
              <div [formGroup]="form" class="checkbox c-checkbox mb-3 form-group">
                <label for="automaticValidationCSC" class="signatory-section-title mb-2 auto-validation">{{'edelivery.automatic_validation.csc' | translate}}</label>
                <div class="mb-2 mt-2"><small class="text-muted mb-2">{{'edelivery.automatic_validation_desc.csc' | translate}}</small></div>
                @if (isEdelivery ) {
                  <label for="automaticValidationCSC" >
                    <input type="checkbox"
                      [id]="'automaticValidationCSC'"
                      formControlName="automaticValidationCSC"
                      [checked]="this.form.get('automaticValidationCSC')?.value"
                      (click)="onAutomaticValidationCheck('csc')">
                      <span class="fa fa-check fa-fw"></span>
                    </label>
                  }
                </div>
              }

              @if ( cscAuthPreviewMethod && automaticValidationCSC?.value ) {
                <div [formGroup]="form" class="form-group mb-3">
                  <label class="signatory-section-title mb-2">{{ 'signrequest.firstName' | translate }}*
                    <br/><small class="text-muted">{{automaticValidationTranslationKey("signrequest.firstName","firstName") | translate: automaticValidationTranslationMethods("firstName")}}</small>
                    <div class="mt-2">
                      <input [value]="cscAuthPreviewMethod?.givenName || null"
                        class="form-control"
                        formControlName="firstname"
                        type="text">
                      </div>
                    </label>
                  </div>
                }

                @if ( (irmaAuthPreviewMethod && automaticValidationIRMA?.value) || (idinAuthPreviewMethod && automaticValidationIDIN?.value) ) {
                  <div [formGroup]="form" class="form-group mb-3">
                    <label class="signatory-section-title mb-2">{{ 'signrequest.initials' | translate }}*
                      <br/><small class="text-muted">{{automaticValidationTranslationKey("signrequest.initials","initials") | translate: automaticValidationTranslationMethods("initials")}}</small>
                      <div class="mt-2">
                        <input [value]="irmaAuthPreviewMethod?.initials || idinAuthPreviewMethod?.initials || null"
                          class="form-control"
                          formControlName="initials"
                          type="text">
                        </div>
                      </label>
                    </div>
                  }

                  @if ( idinAuthPreviewMethod && automaticValidationIDIN?.value ) {
                    <div [formGroup]="form" class="form-group mb-3">
                      <label class="signatory-section-title mb-2">{{ 'signrequest.prefix' | translate }}
                        <br/><small class="text-muted">{{automaticValidationTranslationKey("signrequest.prefix","prefix") | translate: automaticValidationTranslationMethods("prefix")}}</small>
                        <div class="mt-2">
                          <input [value]="idinAuthPreviewMethod?.legalLastnamePrefix || null"
                            class="form-control"
                            formControlName="prefix"
                            type="text">
                          </div>
                        </label>
                      </div>
                    }

                    @if ( (irmaAuthPreviewMethod && automaticValidationIRMA?.value) || (idinAuthPreviewMethod && automaticValidationIDIN?.value) || (cscAuthPreviewMethod && automaticValidationCSC?.value) ) {
                      <div [formGroup]="form" class="form-group mb-3">
                        <label class="signatory-section-title mb-2">{{ 'signrequest.lastName' | translate }}*
                          <br/><small class="text-muted">{{automaticValidationTranslationKey("signrequest.lastName","lastName") | translate: automaticValidationTranslationMethods("lastName")}}</small>
                          <div class="mt-2">
                            <input [value]="idinAuthPreviewMethod?.legalLastname || irmaAuthPreviewMethod?.surname || cscAuthPreviewMethod?.surName || null"
                              class="form-control"
                              formControlName="lastname"
                              type="text">
                            </div>
                          </label>
                        </div>
                      }

                      @if ( (irmaAuthPreviewMethod && automaticValidationIRMA?.value) || (idinAuthPreviewMethod && automaticValidationIDIN?.value) || (cscAuthPreviewMethod && automaticValidationCSC?.value) ) {
                        <div [formGroup]="form" class="form-group mb-3">
                          <label class="signatory-section-title mb-2">{{ 'signrequest.dateOfBirth' | translate }}*
                            <br/><small class="text-muted">{{automaticValidationTranslationKey("signrequest.dateOfBirth","dateOfBirth") | translate: automaticValidationTranslationMethods("dateOfBirth")}}</small>
                            <div class="mt-2">
                              <input [value]="idinAuthPreviewMethod?.dateofbirth || irmaAuthPreviewMethod?.dateofbirth || cscAuthPreviewMethod?.birthDate || null"
                                class="form-control"
                                formControlName="dateofbirth"
                                type="date">
                              </div>
                            </label>
                          </div>
                        }

                        <hr/>
                        @if ( !isEdelivery ) {
                          <div class="form-group mb-3">
                            <label for="authMethods">{{ 'signrequest.authentication' | translate }}</label>

                            <app-auth-methods (toggle)="toggleAuthentication($event)"
                              [enabled]="enabledAuthenticationMethods"
                              [disabled]="disabledAuthenticationMethods"
                              [signatory]="recipient"
                              id="authMethods">
                            </app-auth-methods>
                          </div>
                        }



                        @if ( smstanAuthMethod || smstanAuthPreviewMethod ) {
                          <div [formGroup]="form" class="form-group mb-3 mt-2">
                            <label for="phonenumber" class="signatory-section-title mb-2 auto-validation">
                              <div class="signatory-section-title mb-2">{{ 'contacts.phone' | translate }}*</div>
                              <small class="text-muted">{{'signrequest.phone_smstan' | translate}}</small>
                              <div class="mt-2">
                                <input [value]="recipient.phone || null"
                                  class="form-control"
                                  formControlName="phonenumber"
                                  id="phonenumber"
                                  type="text">
                                </div>
                              </label>
                            </div>
                          }

                          @if ( cscAuthMethod && showProviders ) {
                            <div [formGroup]="form" class="form-group mb-3">
                              <div class="signatory-section-title mt-2">
                                <div class="mb-2"><strong>{{ 'signrequest.cscProviders' | translate }}*</strong></div>
                                @for ( provider of enabledProviders; track provider.id) {
                                  <div class="d-flex align-items-center mb-2">
                                    <div class="checkbox c-checkbox">
                                      <label class="mb-0">
                                        <input type="checkbox"
                                          [id]="provider.id"
                                          [checked]="provider.selected"
                                          (change)="provider.selected = !provider.selected; updateEnabledProviders(enabledProviders, recipient.authenticationMethods)">
                                          <span class="fa fa-fw fa-check"></span>
                                        </label>
                                      </div>

                                      <div style="padding-left: 10px;">
                                        <label style="font-weight: normal; font-style: italic;" class="mb-0" [for]="provider.id">
                                          {{ provider.name }}
                                        </label>
                                      </div>

                                    </div>
                                  }
                                </div>
                              </div>
                            }

                            <div class="mb-3" [hidden]="exclusiveMethod !== 'documenttemplate'">
                              <app-template-selector [selected]="selectedTemplate"
                                (select)="selectTemplate($event)"
                                (hasTemplates)="templatesAvailable($event)"
                              [required]="true"></app-template-selector>
                            </div>
                          }

                          @if ( noContactFound && availableContactList.hidden ) {
                            <div class="contacts">
                              <p class="text-warning mb-4"><em class="fa fa-fw fa-exclamation-triangle"></em>
                              <span [innerHTML]="'signrequest.no_contacts_found' | translate: {name: contactFilter }"></span>
                            </p>
                            <button (click)="createContact(recipient)" class="btn btn-block btn-outline-warning" type="button"><em
                            class="fas fa-plus mr-2"></em> {{ 'contacts.new_contact_name' | translate: {name: contactFilter} }}
                          </button>
                        </div>
                      }
                    </div>
                  }
